import React from "react";
import styled from "styled-components";

import { Box, VisuallyHidden, themeGet, Link, Spacer } from "@fuegokit/react";
import { AkEditFilledIcon } from "@fuegokit/fuegoicons-react";

import { Contributors } from "../Contributors";
import { generatedId } from "../../lib/utils";

const Footer = ({ editUrl, contributors }) => {
  const date = new Date().getFullYear();
  return (
    <StyledFooter>
      <VisuallyHidden>
        <h2>Footer</h2>
      </VisuallyHidden>

      <Box
        sx={{
          py: [4, null, null, 6],
          px: [5, null, null, 10],
          display: "flex",
          flexGrow: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
            alignItems: "flex-end",
            fontSize: 3,
          }}
        >
          {contributors && contributors.length > 0 ? (
            <Contributors contributors={contributors} />
          ) : null}
          {editUrl ? (
            <Link
              subtle
              href={editUrl}
              sx={{
                display: "flex",
                fontWeight: "normal",
                marginLeft: "auto",
                alignItems: "center",
              }}
            >
              <AkEditFilledIcon />
              <Spacer axis={`horizontal`} size={8} />
              Edit this page on Github
            </Link>
          ) : null}
        </Box>
      </Box>
    </StyledFooter>
  );
};
const StyledFooter = styled.footer`
  width: 100%;
  /* background-color: ${themeGet("colors.elevation.surface.raised")}; */
  display: flex;
  flex-direction: column;
  height: "84px";
`;

Footer.displayName = "Footer";
export default Footer;
